import Environment from 'helpers/environment'
import Brand from './brand'

class GA4 {
  static skipGA = false

  static skipGoogleAnalytics (skip: boolean) {
    this.skipGA = skip
  }

  static googleAnalyticsId () {
    if (Environment.isProduction()) {
      return 'G-K3QBG4G20C'
    } else if (Environment.isQA() || Environment.isDevelopment() || Environment.isStaging()) {
      return 'G-8574F9VHMF'
    } else {
      return ''
    }
  }

  static setUserProperties (userId: string | number, roles: string[], dealerId: string | number) {
    if (!Brand.isResidential() || this.skipGA) return

    if (window.gtag === undefined) {
      console.error('gtag is not defined')
      return
    }

    window.gtag('config', GA4.googleAnalyticsId(), {
      'user_id': userId,
      user_properties: {
        userId, // this will be used for custom dimension
        'roles': roles.join(', '), // comma separated list of roles
        'dealer_id': dealerId
      }
    })
  }

  static sendEvent ({ category, action, label, value }: { category: string, action: string, label?: string, value?: string }) {
    if (!Brand.isResidential() || this.skipGA) return

    if (window.gtag === undefined) {
      console.error('gtag is not defined')
      return
    }
    window.gtag(
      'event',
      action, {
        event_category: category,
        event_label: label,
        value
      }
    )
  }
}

export default GA4
